<template>
  <div class="practice">
    <img class="app-main" :src="url" alt="">
    <div class="app-footer">
      <div class="footer-content">
        <img src="../../assets/arc.svg" alt="">
        <div class="footer-main">
          <div class="footer-title">
            <img src="../../assets/title2.png" alt="">
          </div>
          <open-button type="default"></open-button>
        </div>
      </div>
    </div>
    <van-overlay :show="weixin" class-name="app-overlay">
      <div class="wrapper" @click.stop>
        <div class="app-arrow">
          <img src="../../assets/arrow.png" alt="">
        </div>
        <div class="app-desc">
          <div class="text">微信中无法直接下载，点击右上角“…” </div>
          <div class="text">选择在浏览器中打开</div>
        </div>
        <div class="app-guide">
          <img src="../../assets/guide.png" alt="">
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import openButton from '../../components/openButton'
import qs from 'qs'
import { isWeixin } from "@/utils";
import {getDownloadBanner} from "../../api"

export default {
  name: 'Practice',
  components:{
    openButton
  },
  data(){
    return {
      url:"",
      weixin: false,
    }
  },
  mounted(){
    getDownloadBanner({"code":"Ad-sjgf-download-practice"}).then(res=>{
      this.url=res.data[0].url
      console.log(this.url);
    })
    this.channelViewMonitor()
    this.weixin = isWeixin()
  },
  methods:{
    channelViewMonitor(){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('channel_appDownloadPage_view', { code });
    }
  }
}
</script>

<style lang="scss" scoped>
.practice{
  height: 100%;
  background: #EEEFF0;
  position: relative;
  .app-main{
    width: 100%;
  }
  .app-footer{
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    img{
      width: 100%;
      position: relative;
      bottom: -6px;
    }
    .footer-content{
      font-size: 0;
      .footer-title{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px 40px 30px 0;
        img{
          width: 400px;
        }
      }
      .footer-main{
        position: relative;
        z-index: 1;
        min-height: 320px;
        padding-bottom: 56px;
        background: white;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      }
    }
  }
  .app-overlay{
    width: 100%;
    .wrapper{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .app-arrow{
        width: 100%;
        display: flex;
        justify-content: flex-end;
        img{
          margin: 28px 36px 32px 0;
          height: 88px;
        }
      }
      .app-desc{
        margin-bottom: 64px;
        .text{
          text-align: center;
          width: 551px;
          font-size: 32px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 52px;
        }
      }
      .app-guide{
        margin-bottom: 88px;
        img{
          width: 686px;
        }
      }
    }
  }
}
</style>
